import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

const CARDS = [
  {
    key: "miroir",
    to: "/pellicules/miroir",
    image: "/images/miroir-hero.webp",
  },
  {
    key: "givre",
    to: "/pellicules/givre",
    image: "/images/givre-hero.webp",
  },
  {
    key: "securite",
    to: "/pellicules/securite",
    image: "/images/securite-commerce.webp",
  },
];

export default function Films() {
  const { t } = useLanguage();
  usePageMeta("films");

  return (
    <div className="animate-fade-up">
      {/* HEADER */}
      <section className="py-20 sm:py-28 lg:py-40 bg-slate-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-xs tracking-[0.3em] uppercase font-display font-semibold text-blue-600">{t("films.eyebrow")}</div>
          <h1 data-testid="films-title" className="font-heading text-5xl lg:text-7xl font-normal tracking-tight leading-[1.15] text-slate-900 mt-4 max-w-4xl">
            {t("films.title")}
          </h1>
          <p className="mt-8 text-lg text-slate-600 max-w-2xl leading-relaxed font-normal">
            {t("films.subtitle")}
          </p>
        </div>
      </section>

      {/* TWO FILM CARDS */}
      <section className="py-20 sm:py-28 lg:py-40 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {CARDS.map((c) => {
            const card = t(`films.${c.key}Card`);
            return (
              <Link
                key={c.key}
                to={c.to}
                data-testid={`film-card-${c.key}`}
                className="group block rounded-2xl overflow-hidden bg-white border border-slate-200 hover:border-blue-200 transition-colors"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={c.image}
                    alt={card.label}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-8 lg:p-10">
                  <h2 className="font-heading text-2xl lg:text-3xl font-normal text-slate-900">{card.label}</h2>
                  <p className="mt-3 text-slate-600 leading-relaxed font-normal">{card.short}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-blue-600 group-hover:gap-3 transition-all">
                    {card.cta}
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
